<template>
  <div class="product-new-event">
    <snow-steps v-model="currentStep" :steps="steps" />
    <component
      :is="stepContent"
      :form="form"
      :savedLots="savedLots"
      @set-lots="setLots"
      @reset-end-date="resetEndDate"
    />

    <div
      class="d-flex flex-column flex-md-row justify-content-end my-9 px-3 gap-4"
    >
      <snow-button
        class="order-1 order-md-0"
        @click="back"
        variant="gray"
        :icon="currentStep !== 1 ? 'fa-light fa-angle-left' : ''"
        :text="currentStep === 1 ? 'Cancelar' : 'Voltar'"
      >
      </snow-button>
      <snow-button
        :disabled="!isValid"
        :rightIcon="
          currentStep !== steps.length ? 'fa-light fa-angle-right' : ''
        "
        :text="currentStep === steps.length ? 'Salvar Evento' : 'Próximo'"
        @click="next"
      >
      </snow-button>
    </div>
  </div>
</template>
<script>
import AddLots from "@/components/product/events/AddLots.vue";
import BasicInformation from "@/components/product/events/BasicInformation.vue";
import Pricing from "@/components/product/events/Pricing.vue";
import SnowSteps from "@/components/snow-ui/SnowSteps.vue";
import { clearObject, formFields, toComputerDate } from "@/functions/helpers";

export default {
  components: { SnowSteps },
  data() {
    return {
      currentStep: 2,
      steps: [
        "Tipo de produto",
        "Informações básicas",
        "Precificação",
        "Cadastrar ingresso"
      ],
      ...formFields(
        [
          "name",
          "description",
          "event_location",
          "event_address",
          "event_start_at",
          "event_end_at",
          "category_id",
          "picture",
          "currency",
          "payment_methods_ids",
          "is_tax_to_producer",
          "warranty",
          "type_product",
          "installments",
          "billet_installments",
          "billet_apply_interest"
        ],
        {
          currency: "BRL",
          type_product: "onsite_event",
          payment_methods_ids: []
        }
      ),
      savedLots: [],
      loading: false
    };
  },
  computed: {
    stepDescription() {
      const descriptions = [
        "Através dessas informações seu cliente vai identificar o seu evento.",
        "Essa imagem aparecerá para você na listagem de seus produtos e no checkout para seus compradores.",
        "Informe como você deseja monetizar o seu evento.",
        "Cadastre os ingressos para vendas do seu evento."
      ];
      return descriptions[this.currentStep - 2];
    },
    stepContent() {
      const content = [BasicInformation, Pricing, AddLots];
      return content[this.currentStep - 2];
    },
    isValid() {
      const validStep2 =
        ![
          "name",
          "description",
          "event_location",
          "event_address",
          "event_start_at",
          "event_end_at",
          "category_id"
        ].find(f => !this.form[f]) &&
        this.form.name.length <= 64 &&
        this.form.description.length <= 980;

      const validStep3 =
        !["currency", "warranty"].find(f => !this.form[f]) &&
        this.form.payment_methods_ids.length;

      switch (this.currentStep) {
        case 2:
          return validStep2;
        case 3:
          return validStep3;
        case 4:
          return this.savedLots.length;
        default:
          return true;
      }
    }
  },
  methods: {
    back() {
      this.currentStep--;
    },
    next() {
      if (this.currentStep < 4) this.currentStep++;
      else this.submit();
    },
    setLots(lots) {
      this.savedLots = lots;
    },
    resetEndDate() {
      this.form.event_end_at = "";
    },
    async submit() {
      this.loading = true;

      try {
        const form = {
          ...this.form,
          option_form: {
            request_address_shopper: false,
            request_cpf_cnpj_shopper: true,
            request_phone_shopper: false,
            coupon_shopper: false,
            instagram_shopper: false,
            request_zip_code: false,
            pos_address_shopper: false
          },
          event_start_at: toComputerDate(this.form.event_start_at),
          event_end_at: toComputerDate(this.form.event_end_at)
        };

        if (
          !form.payment_methods_ids.filter(id => [1, 3, 34].includes(id)).length
        ) {
          form.installments = 1;
          form.is_tax_to_producer = false;
        }

        if (form.payment_methods_ids.includes("parceled_billet")) {
          form.payment_methods_ids = [2];
        } else {
          form.billet_installments = 1;
          form.billet_apply_interest = false;
        }

        form.price_eur = form.price_eur === 0 ? "" : form.price_eur;
        form.price_usd = form.price_usd === 0 ? "" : form.price_usd;

        const {
          data: { id }
        } = await this.$store.dispatch("product/post", form);

        await this.submitLots(id);

        this.$router.push({ name: "product" });
      } catch {
        this.$message.error("Erro ao criar evento");
      }
    },
    async submitLots(product_id) {
      const createdLots = {};

      const addLot = async lot => {
        const temp_id = lot.id;

        let data = { ...lot };
        data.parent_id = createdLots[data.parent_id];
        data.status = "enabled";
        data.product_id = product_id;
        data.start_at = toComputerDate(data.start_at);
        data.end_at = toComputerDate(data.end_at);
        data.price_usd === 0 ? delete data.price_usd : data.price_usd;
        data.price_eur === 0 ? delete data.price_eur : data.price_eur;
        delete data.id;

        const {
          data: { id }
        } = await this.$store.dispatch("events/createLot", clearObject(data));

        createdLots[temp_id] = id;
      };

      for (const lot of this.savedLots) {
        await addLot(lot);
      }
    }
  },
  watch: {
    currentStep(v) {
      if (v === 1) this.$router.push({ name: "product-new" });
    }
  },
  mounted() {
    this.$store.dispatch("product/getPaymentMethods");
  }
};
</script>
